"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4842,2054,748,4678,6576,294,9683,3812,8741,7480],{

/***/ 51250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ EXTEND_SKU; }
/* harmony export */ });
var EXTEND_SKU = ";xtd;";


/***/ }),

/***/ 49125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ SHIPPED_SHIELD_SKU; }
/* harmony export */ });
var SHIPPED_SHIELD_SKU = "WORRY_FREE_DELIVERY";


/***/ }),

/***/ 68533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ WORRY_FREE_DELIVERY_SKU; }
/* harmony export */ });
var WORRY_FREE_DELIVERY_SKU = "WORRY_FREE_DELIVERY";


/***/ }),

/***/ 32054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DEFAULT_CHECKOUT_VARIANT": function() { return /* binding */ DEFAULT_CHECKOUT_VARIANT; },
/* harmony export */   "checkVariantNameIsSize": function() { return /* binding */ checkVariantNameIsSize; },
/* harmony export */   "formatPrice": function() { return /* binding */ formatPrice; },
/* harmony export */   "formatPriceRange": function() { return /* binding */ formatPriceRange; },
/* harmony export */   "formatPriceValue": function() { return /* binding */ formatPriceValue; },
/* harmony export */   "getCookieByName": function() { return /* binding */ getCookieByName; },
/* harmony export */   "getCustomerDetails": function() { return /* binding */ getCustomerDetails; },
/* harmony export */   "getCustomerOrderCount": function() { return /* binding */ getCustomerOrderCount; },
/* harmony export */   "getPriceOrPriceRange": function() { return /* binding */ getPriceOrPriceRange; },
/* harmony export */   "getWindowAgent": function() { return /* binding */ getWindowAgent; },
/* harmony export */   "priceValue": function() { return /* binding */ priceValue; },
/* harmony export */   "productClickGa": function() { return /* binding */ productClickGa; },
/* harmony export */   "productUpdateGA": function() { return /* binding */ productUpdateGA; },
/* harmony export */   "removeSpecialChars": function() { return /* binding */ removeSpecialChars; },
/* harmony export */   "sizeArray": function() { return /* binding */ sizeArray; },
/* harmony export */   "sleep": function() { return /* binding */ sleep; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var _codebuild_output_src1400200473_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src1400200473_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src1400200473_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _services_Log__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27429);
/* harmony import */ var _allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48080);






var getCustomerDetails = function() {
    try {
        var customerDetails = localStorage.getItem("customer");
        if (customerDetails) {
            var ref = JSON.parse(customerDetails), customerId = ref.customerId, customerEmail = ref.customerEmail;
            if ((typeof customerId === "number" || typeof customerId === "string") && typeof customerEmail === "string") {
                return {
                    customerId: customerId,
                    customerEmail: customerEmail
                };
            }
        }
    } catch (err) {
        (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .error */ .vU)("Failed to get customer details from localStorage");
    }
    return {
        customerId: 0,
        customerEmail: ""
    };
};
var kebabCase = function(str) {
    return "".concat(str || "").replace(/([a-z])([A-Z])/g, "$1-$2") // get all lowercase letters that are near to uppercase ones
    .replace(/[\s_]+/g, "-") // replace all spaces and low dash
    .toLowerCase();
};
var productClickGa = function(param) {
    var product = param.product, position = param.position, category = param.category;
    var sendToGA = function() {
        if (true) {
            var customer = getCustomerDetails();
            var customerId = customer === null || customer === void 0 ? void 0 : customer.customerId;
            var customerEmail = customer === null || customer === void 0 ? void 0 : customer.customerEmail;
            var visitorType = customerEmail ? "Logged In" : "Guest";
            // Define the event object with the correct structure.
            var eventData = {
                event: "productClick",
                ecommerce: {
                    visitorType: visitorType,
                    customerId: customerId,
                    click: {
                        actionField: {
                            list: kebabCase(category)
                        },
                        products: [
                            {
                                name: product.name,
                                id: product.variants[0].sku,
                                price: product.calculated_price,
                                brand: product.brand || "",
                                category: category,
                                variant: product.variants[0].id,
                                position: position
                            }
                        ]
                    }
                },
                customerEmail: customerEmail
            };
            // Push event data to the dataLayer with type safety.
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                ecommerce: null
            }) // Clear the previous ecommerce object.
            ;
            window.dataLayer.push(eventData);
        }
    };
    if (window.loadedAndInteractive) {
        sendToGA();
    } else {
        window.addEventListener("loadedAndInteractive", sendToGA, {
            once: true
        });
    }
};
var productUpdateGA = function(lineItem, event, cartTotal) {
    var sendToGA = function() {
        try {
            var customer = getCustomerDetails();
            var customerId = customer === null || customer === void 0 ? void 0 : customer.customerId;
            var customerEmail = customer === null || customer === void 0 ? void 0 : customer.customerEmail;
            var visitorType = customerEmail ? "Logged In" : "Guest";
            var keyName = event === "addToCart" ? "add" : "remove";
            var _obj;
            // Create the correct GA event based on the input event type.
            var eventData = {
                event: event,
                ecommerce: (_obj = {
                    visitorType: visitorType,
                    customerId: customerId
                }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, keyName, {
                    products: [
                        {
                            name: lineItem.name,
                            // for grouped products like quilts, do you have a default that you can use?
                            id: lineItem.sku,
                            // for grouped products like quilts, do you have a default that you can use?
                            price: lineItem.originalPrice,
                            // for grouped products like quilts, do you have a default that you can use?
                            salePrice: lineItem.salePrice,
                            brand: lineItem.brand,
                            variant: lineItem.variantId,
                            quantity: lineItem.quantity
                        }
                    ]
                }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, "customerEmail", customerEmail), _obj),
                cartTotal: cartTotal
            };
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                ecommerce: null
            }) // Clear the previous ecommerce object.
            ;
            window.dataLayer.push(eventData);
        } catch (err) {
            (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .error */ .vU)("Failed to send GA event", err);
        }
    };
    if (window.loadedAndInteractive) {
        sendToGA();
    } else {
        window.addEventListener("loadedAndInteractive", sendToGA, {
            once: true
        });
    }
};
var getCustomerOrderCount = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_codebuild_output_src1400200473_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var orderCountFromStorage, ref, getCustomer, getCustomerOrders, ref1, customer, success, orderCount;
        return _codebuild_output_src1400200473_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    orderCountFromStorage = sessionStorage.getItem("customerOrderCount");
                    if (!(orderCountFromStorage !== null && orderCountFromStorage)) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return", parseInt(orderCountFromStorage));
                case 3:
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z;
                    _ctx.next = 6;
                    return (0,_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
                        return [
                            __webpack_require__.e(/* import() */ 7941).then(__webpack_require__.bind(__webpack_require__, 57941)),
                            __webpack_require__.e(/* import() */ 1950).then(__webpack_require__.bind(__webpack_require__, 41950)), 
                        ];
                    });
                case 6:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 2);
                    getCustomer = ref[0].getCustomer;
                    getCustomerOrders = ref[1].getCustomerOrders;
                    _ctx.next = 12;
                    return getCustomer();
                case 12:
                    ref1 = _ctx.sent;
                    customer = ref1.customer;
                    success = ref1.success;
                    if (!(!success || !customer)) {
                        _ctx.next = 17;
                        break;
                    }
                    return _ctx.abrupt("return", 0);
                case 17:
                    _ctx.next = 19;
                    return getCustomerOrders({
                        sort: "date_created:desc"
                    });
                case 19:
                    orderCount = _ctx.sent.length;
                    sessionStorage.setItem("customerOrderCount", "".concat(orderCount));
                    return _ctx.abrupt("return", orderCount);
                case 22:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getCustomerOrderCount() {
        return _ref.apply(this, arguments);
    };
}();
var formatPrice = function(price) {
    var digit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    // using parseFloat to make sure this function works for both number and string
    var floatPrice = parseFloat("".concat(price || ""));
    if (!Number.isFinite(floatPrice)) {
        return price;
    }
    return "$".concat(parseFloat("".concat(price || "")).toFixed(digit));
};
var formatPriceValue = function(price) {
    var digit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    var floatPrice = parseFloat(String(price));
    if (!Number.isFinite(floatPrice)) {
        return price;
    }
    return Number(parseFloat(String(price)).toFixed(digit));
};
// using parseFloat to make sure this function works for both number and string
var formatPriceRange = function(minPrice, maxPrice) {
    var digit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
    return "".concat(formatPrice(minPrice, digit) || "", " - ").concat(formatPrice(maxPrice, digit) || "");
};
var getPriceOrPriceRange = function(product, priceType) {
    var ref;
    var variants = product.variants;
    var sortedVariantPrices = (ref = variants === null || variants === void 0 ? void 0 : variants.map(function(variant) {
        return parseFloat("".concat(variant[priceType]));
    })) === null || ref === void 0 ? void 0 : ref.sort();
    var minPrice = variants ? sortedVariantPrices[0] : product[priceType];
    var maxPrice = variants ? sortedVariantPrices.pop() : product[priceType];
    return minPrice === maxPrice ? formatPrice(minPrice) : formatPriceRange(minPrice, maxPrice);
};
var sizeArray = [
    "small",
    "medium",
    "large",
    "extra small",
    "extra large",
    "long",
    "tall",
    "short"
];
var checkVariantNameIsSize = function(el) {
    var name = el.option_values[0].label.toLowerCase();
    if (/^\d/.test(name) || sizeArray.includes(name)) {
        return true;
    }
    return false;
};
var priceValue = function(price) {
    return price.split("$")[1];
};
var removeSpecialChars = function(string) {
    var regex = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : /[^a-zA-Z \s0-9,'\-#.*&]/g;
    return "".concat(string).replace(regex, "");
};
var getCookieByName = function(name, cookiesFromRequest) {
    var cookies;
    if (globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
        var _cookie;
        cookies = (_cookie = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document.cookie) !== null && _cookie !== void 0 ? _cookie : "";
    } else {
        cookies = cookiesFromRequest !== null && cookiesFromRequest !== void 0 ? cookiesFromRequest : "";
    }
    if (cookies) {
        var ref, ref1;
        var ref2;
        var cookieName = (ref2 = (ref = cookies.split(";")) === null || ref === void 0 ? void 0 : ref.find(function(cookie) {
            return cookie.includes(name);
        })) !== null && ref2 !== void 0 ? ref2 : "";
        return (ref1 = cookieName === null || cookieName === void 0 ? void 0 : cookieName.split("=")) === null || ref1 === void 0 ? void 0 : ref1[1];
    }
    return "";
};
// IDs for each variant within an experiment are numeric and indexed at 0
var DEFAULT_CHECKOUT_VARIANT = "0";
var sleep = function(ms) {
    return new Promise(function(r) {
        return setTimeout(r, ms);
    });
};
var getWindowAgent = function(nextContextReq) {
    // Ref: https://stackoverflow.com/questions/59494037/how-to-detect-the-device-on-react-ssr-app-with-next-js
    // if you are on the server and you get a 'nextContextReq' property from your context
    if (nextContextReq) {
        // get the user-agent from the headers
        return nextContextReq.headers["user-agent"];
    }
    // if you are on the client you can access the navigator from the window object
    return navigator.userAgent;
};


/***/ }),

/***/ 10304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ isShippingProtection; },
/* harmony export */   "Y": function() { return /* binding */ isNotShippingProtection; }
/* harmony export */ });
/* harmony import */ var _data_constants_SHIPPED_SHIELD_SKU__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49125);
/* harmony import */ var _data_constants_WORRY_FREE_DELIVERY_SKU__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68533);


var isShippingProtection = function(item) {
    return item.sku.includes(_data_constants_SHIPPED_SHIELD_SKU__WEBPACK_IMPORTED_MODULE_0__/* .SHIPPED_SHIELD_SKU */ .E) || item.sku.includes(_data_constants_WORRY_FREE_DELIVERY_SKU__WEBPACK_IMPORTED_MODULE_1__/* .WORRY_FREE_DELIVERY_SKU */ .f);
};
var isNotShippingProtection = function(item) {
    return !isShippingProtection(item);
};


/***/ }),

/***/ 99486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ ClientSideCache; }
});

// UNUSED EXPORTS: ClientSideCacheWithGeneric

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./helpers/FP.ts
var FP = __webpack_require__(13174);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/crypto-browserify/index.js
var crypto_browserify = __webpack_require__(42474);
;// CONCATENATED MODULE: ./helpers/jsonObjectToHash.ts

var jsonObjectToHash = function(json) {
    return (0,crypto_browserify.createHash)("sha256").update(JSON.stringify(json)).digest("hex");
};

// EXTERNAL MODULE: ./node_modules/@recoiljs/refine/es/index.js
var es = __webpack_require__(30901);
// EXTERNAL MODULE: ./services/Log.ts
var Log = __webpack_require__(27429);
;// CONCATENATED MODULE: ./services/ClientSideCache.ts





var MAX_FIFO_QUEUE_SIZE = 50;
var Cache = (0,es/* writableDict */.AE)((0,es/* writableDict */.AE)((0,es/* mixed */.nK)()));
var CacheLocalStorage = (0,es/* object */.Ry)({
    lastInteractionUnixTimeStamp: (0,es/* number */.Rx)(),
    cache: Cache
});
var maxDelayToDiscardCache = 1000 * 60 * 60 // 60 minutes
;
var assertCacheIsFreshEnough = function(cache) {
    var now = Date.now();
    var timeElapsed = now - cache.lastInteractionUnixTimeStamp;
    if (timeElapsed > maxDelayToDiscardCache) {
        // throw new Error('Cache is too old')
        return {};
    }
    return cache.cache;
};
var asseertCacheLocalStorage = (0,es/* assertion */.P5)(CacheLocalStorage, "Failed to assert CacheLocalStorage");
var loadCacheFromLocalStorage = (0,FP/* caught */.$P)(function() {
    if (typeof localStorage === "undefined") {
        return {};
    }
    var rawLocalStorage = localStorage.getItem("ClientSideGlobalFifoCacheStorage");
    if (!rawLocalStorage) {
        return {};
    }
    var localStorageCache = asseertCacheLocalStorage(JSON.parse(localStorage.getItem("ClientSideGlobalFifoCacheStorage") || "{}"));
    return assertCacheIsFreshEnough(localStorageCache);
})(function(err) {
    (0,Log/* error */.vU)("Failed to load ClientSideGlobalFifoCacheStorage from localStorage", err);
    return {};
});
var saveCacheToLocalStorage = (0,FP/* caught */.$P)(function(cache) {
    if (typeof localStorage === "undefined") {
        return;
    }
    localStorage.setItem("ClientSideGlobalFifoCacheStorage", JSON.stringify({
        cache: cache,
        lastInteractionUnixTimeStamp: Date.now()
    }));
})(function(err) {
    (0,Log/* error */.vU)("Failed to save ClientSideGlobalFifoCacheStorage to localStorage", err);
});
var ClientSideGlobalFifoCacheStorage = loadCacheFromLocalStorage(undefined);
var FifoStorage = [];
var AppendGlobalCache = function(param) {
    var key = param.key, space = param.space, value = param.value;
    ClientSideGlobalFifoCacheStorage[space] = ClientSideGlobalFifoCacheStorage[space] || {};
    ClientSideGlobalFifoCacheStorage[space][key] = value;
    FifoStorage.push({
        space: space,
        key: key
    });
    if (FifoStorage.length > MAX_FIFO_QUEUE_SIZE) {
        var removable = FifoStorage.shift();
        if (removable && !(removable.space === space && removable.key === key)) {
            delete ClientSideGlobalFifoCacheStorage[removable.space][removable.key];
        }
    }
    saveCacheToLocalStorage(ClientSideGlobalFifoCacheStorage);
};
var GlobalCacheContains = function(param) {
    var key = param.key, space = param.space;
    return typeof ClientSideGlobalFifoCacheStorage[space] !== "undefined" && typeof ClientSideGlobalFifoCacheStorage[space][key] !== "undefined";
};
var GlobalCacheAccess = function(param) {
    var key = param.key, space = param.space;
    return ClientSideGlobalFifoCacheStorage[space][key];
};
var allSpaces = [];
var ClientSideCacheWithGeneric = function(spaceTrack) {
    return function(computation) {
        return function(functor) {
            if (false) {}
            var space = jsonObjectToHash({
                spaceTrack: spaceTrack
            });
            allSpaces.push(space);
            (0,Log/* log */.cM)("ClientSideCacheWithGeneric", {
                spaceTrack: spaceTrack,
                space: space,
                allSpaces: allSpaces
            });
            var returnFunctor = function(args) {
                var key = computation(args);
                var cacheHit = GlobalCacheContains({
                    space: space,
                    key: key
                });
                var valuePromise = cacheHit ? GlobalCacheAccess({
                    space: space,
                    key: key
                }) : functor(args);
                if ((0,_instanceof/* default */.Z)(valuePromise, Promise)) {
                    valuePromise.then(function(value) {
                        return AppendGlobalCache({
                            space: space,
                            key: key,
                            value: value
                        });
                    });
                } else {
                    AppendGlobalCache({
                        space: space,
                        key: key,
                        value: valuePromise
                    });
                }
                return valuePromise;
            };
            returnFunctor.clearCache = function(key) {
                delete ClientSideGlobalFifoCacheStorage[space][key];
                saveCacheToLocalStorage(ClientSideGlobalFifoCacheStorage);
            };
            returnFunctor.setCache = function(key, value) {
                AppendGlobalCache({
                    space: space,
                    key: key,
                    value: value
                });
            };
            return returnFunctor;
        };
    };
};
var ClientSideCache = ClientSideCacheWithGeneric;


/***/ }),

/***/ 16033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$z": function() { return /* binding */ setOptOut; },
/* harmony export */   "Lt": function() { return /* binding */ setOptIn; },
/* harmony export */   "kg": function() { return /* binding */ clearCustomerOptOut; },
/* harmony export */   "rq": function() { return /* binding */ customerOptedOutOfWFD; }
/* harmony export */ });
// we will use session storage to store the customer's decision to add/remove delivery protection
var setOptOut = function() {
    return localStorage.setItem("WORRY_FREE_DELIVER", "false");
};
var setOptIn = function() {
    return localStorage.setItem("WORRY_FREE_DELIVER", "true");
};
var clearCustomerOptOut = function() {
    return localStorage.removeItem("WORRY_FREE_DELIVER");
};
var customerOptedOutOfWFD = function() {
    return localStorage.getItem("WORRY_FREE_DELIVER") === "false";
};


/***/ })

}]);